import { useMemo } from "react";
import type { ChainType } from "~/api/types";
import { isValidAddress } from "~/lib/address";

const CHAIN_FAMILY_LABELS: Record<ChainType, string> = {
  evm: "EVM",
  solana: "Solana",
  tron: "Tron",
};

interface RecipientInputProps {
  chainType: ChainType;
  chainName: string;
  value: string;
  onChange: (value: string) => void;
}

export function RecipientInput({ chainType, chainName, value, onChange }: RecipientInputProps) {
  const validation = useMemo(() => {
    if (!value) return "empty";
    return isValidAddress(value, chainType) ? "valid" : "invalid";
  }, [value, chainType]);

  return (
    <div className="rounded-[var(--radius-lg)] border border-[var(--color-border-card-section)] bg-[var(--color-bg-card-section)] p-3">
      <label className="mb-2 block text-sm font-medium text-[var(--color-text-secondary)]">
        Recipient on {chainName}
      </label>
      <input
        type="text"
        placeholder={`Enter ${CHAIN_FAMILY_LABELS[chainType]} address`}
        value={value}
        onChange={(e) => onChange(e.target.value.trim())}
        spellCheck={false}
        autoComplete="off"
        className={`w-full rounded-lg border bg-transparent px-3 py-2 font-mono text-sm text-[var(--color-text-primary)] placeholder:text-[var(--color-text-muted)] focus:outline-none ${
          validation === "invalid"
            ? "border-red-500/60"
            : validation === "valid"
              ? "border-green-500/40"
              : "border-[var(--color-border-card-section)]"
        }`}
      />
      {validation === "invalid" && (
        <p className="mt-1 text-xs text-red-400">
          Not a valid {CHAIN_FAMILY_LABELS[chainType]} address
        </p>
      )}
    </div>
  );
}
